module.exports = __webpack_public_path__ + "c6f4023aa352135000ed1197ac2337c2.svg";